import { createContext, useContext, useEffect, useState, useCallback } from "react";

const HoldingsContext = createContext(null);
const KEY = "alphaapeing_holdings";

export const HoldingsProvider = ({ children }) => {
  const [holdings, setHoldings] = useState([]); // [{ address, amount }]

  useEffect(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(KEY) || "[]");
      setHoldings(Array.isArray(saved) ? saved : []);
    } catch {
      setHoldings([]);
    }
  }, []);

  const write = (next) => localStorage.setItem(KEY, JSON.stringify(next));

  const addHolding = useCallback((address, amount) => {
    setHoldings((prev) => {
      const exists = prev.some((h) => h.address === address);
      const next = exists
        ? prev.map((h) => (h.address === address ? { ...h, amount } : h))
        : [...prev, { address, amount }];
      write(next);
      return next;
    });
  }, []);

  const updateAmount = useCallback((address, amount) => {
    setHoldings((prev) => {
      const next = prev.map((h) => (h.address === address ? { ...h, amount } : h));
      write(next);
      return next;
    });
  }, []);

  const removeHolding = useCallback((address) => {
    setHoldings((prev) => {
      const next = prev.filter((h) => h.address !== address);
      write(next);
      return next;
    });
  }, []);

  return (
    <HoldingsContext.Provider value={{ holdings, addHolding, updateAmount, removeHolding }}>
      {children}
    </HoldingsContext.Provider>
  );
};

export const useHoldings = () => useContext(HoldingsContext);
